<template>
   <div class="scence">
    <div class="content">
      <!-- <div class="tabs">
        <div class="country" v-for="(item,index) in cusMulSelectData" :key="index">
            <span @click="setListCheck(index, item.value)" :class="[ choosed === index ? 'countryon' : '' ]">{{item.label}}</span>
        </div> -->
      <!-- </div> -->
      <!-- <cusMulSelect :name="name" :data="cusMulSelectData" :selectData.sync="selectData"></cusMulSelect> -->
      <div class="skt" ref="skt">
        <div class="select">
          <span class="xzqh">站名:</span>
          <div class="selcountry">
          <el-input
            placeholder="请输入测站名称"
            v-model="query.stnm"
            @keyup.enter.native="onLoadData"
            class="filter-item"
            style="width: 150px;"
            clearable
             @change="Global.emptyQuery(query.stnm,onLoadData)"
          ></el-input>
          </div>
          <span class="search" @click="onLoadData">查询</span>
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table :data="waterdata"  :span-method="objectSpanMethod" v-loading="loading" :max-height="height" border fit highlight-current-row style="width: 100%">
              <el-table-column type="index" width="60" align="center" label="序号"></el-table-column>
              <el-table-column align="center" label="站名" prop="stationName"></el-table-column>
              <el-table-column align="center" label="乡镇" prop="stlc">
                <template slot-scope="scope">
                  <span>{{ !scope.row.stlc ? '-' : scope.row.stlc }}</span>
                </template>
              </el-table-column>
              <el-table-column  label="测站类型" prop="ptno" min-width="70" align="center">
                <template slot-scope="scope">
                  <span>{{ !scope.row.sttpStr ? '-' : scope.row.sttpStr }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column align="center" label="库水位(m)" prop="rz" min-width="70">
                <template slot-scope="scope">
                  <span>{{ !scope.row.rz ? '-' : scope.row.rz }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="蓄水量(万m³)" prop="w" min-width="70">
                <template slot-scope="scope">
                  <span>{{ !scope.row.w ? '-' : scope.row.w }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="水面面积（10^5m²）" prop="w" min-width="70">
                <template slot-scope="scope">
                  <span>{{ !scope.row.wsfa ? '-' : scope.row.wsfa }}</span>
                </template>
              </el-table-column> -->
              <el-table-column align="center" min-width="70" label="操作">
                <template slot-scope="scope" >
                  <div class="operation">
                    <!-- <span v-if="allowsPerm.update" class="edit" @click="onEdit(scope.row)"><span class="edit-icon"></span>编辑</span> -->
                    <span class="edit" @click="onEdit(scope.row)"><span class="edit-icon"></span>编辑</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            </div>
          </div>
      </div>
    </div>
    <el-dialog :title="diagTitle" :visible.sync="diagShow" :close-on-click-modal='false' class="edit_dialog">
      <el-row>
      <el-col :span="12">
        <div class="grid-content bg-purple">
           <el-table :data="editdata" v-loading="loading2" :max-height="500" border fit highlight-current-row style="width: 100%" ref="tableHeight">
        <el-table-column type="index" width="60" align="center" label="序号"></el-table-column>
        <el-table-column align="center" label="水位(m)" prop="z">
          <template slot-scope="scope" >
            <input type="number" class="editInput" v-model="scope.row.z" >
          </template>
        </el-table-column>
        <el-table-column align="center" label="库容(万m³)" prop="value">
          <template slot-scope="scope" >
            <input type="number" class="editInput" v-model="scope.row.v">
          </template>
        </el-table-column>
        <el-table-column align="center" label="施测时间" prop="mstm" min-width="70">
          <template slot-scope="scope">
            <input type="number" class="editInput" v-model="scope.row.mstm">
            <!-- <span>{{ !scope.row.mstm ? '-' : scope.row.mstm }}</span> -->
          </template>
        </el-table-column>
        <el-table-column align="center" label="点序号" prop="ptno" min-width="70">
          <template slot-scope="scope">
            <input type="number" class="editInput" v-model="scope.row.ptno">
            <!-- <span>{{ !scope.row.ptno ? '-' : scope.row.ptno }}</span> -->
          </template>
        </el-table-column>
        <el-table-column align="center" label="水面面积（10^5m²）" prop="wsfa" min-width="110">
          <template slot-scope="scope">
            <input type="number" class="editInput" v-model="scope.row.wsfa">
            <!-- <span>{{ !scope.row.wsfa ? '-' : scope.row.wsfa }}</span> -->
          </template>
        </el-table-column>
      </el-table>
        </div>
      </el-col>
      <el-col :span="12" >
        <div class="grid-content bg-purple-light" >
          <div class="chartContainer">
            <div id="storageLine" style="max-height:500px" ref="lineHeight"></div>
          </div>
        </div>
      </el-col>
    </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="diagShow = false">取消</el-button>
        <el-button type="primary" @click="onSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import userTypes from '@/store/types/user'
import scenceTypes from '@/store/types/scence'

// import cusMulSelect from '@/components/CusMulSelect.vue'
export default {
  // components: { cusMulSelect },
  data () {
    return {
      stcd: '',
      singleData: {},
      name: '类型:',
      choosed: 0,
      selectData: '',
      loading: false,
      diagShow: false,
      diagTitle: '编辑',
      height: 200,
      loading2: false,
      query: {
        // searchName: '',
        stnm: ''
        // sid: '22',
        // pageIndex: 1,
        // pageSize: 100,
        // sttp: 'ZZ'
      },
      waterdata: [],
      spanArr: [],
      editdata: [],
      rules: {
        ensure: [
          { validator: this.Global.checkNumeral, trigger: 'blur' },
          { required: true, message: '请输入数字' }
        ],
        vigilance: [
          { validator: this.Global.checkNumeral, trigger: 'blur' },
          { required: true, message: '请输入数字' }
        ],
        floodLimit: [
          { validator: this.Global.checkNumeral, trigger: 'blur' },
          { required: true, message: '请输入数字' }
        ]
        // userName: [
        //   { required: true, message: '用户名不能为空' },
        //   { min: 4, message: '不能小于4个字符' }
        // ],
        // displayName: [
        //   { required: true, message: '姓名不能为空' }
        // ],
        // adcdCode: [
        //   { required: false, message: '请选择所在地区' }
        // ],
        // gender: [
        //   { required: false, message: '性别不能为空' }
        // ],
        // password: [
        //   { required: true, message: '密码不能为空', trigger: 'blur' }
        // ],
        // Roles: [
        //   { required: true, message: '角色不能为空', trigger: 'change' }
        // ]
      }
    }
  },
  watch: {
    'selectData': function (newVal) {
      if (newVal === 'ZZ') {
        this.query.sttp = 'ZZ'
      } else if (newVal === 'RR') {
        this.query.sttp = 'RR'
      }
      this.onLoadData()
    }
  },
  methods: {
    setListCheck (index, value) {
      this.choosed = index
      this.selectData = value
    },
    onLoadData () {
      this.loading = true
      if (this.query.stnm === '') {
        this.query.stnm = null
      }
      this.$store.dispatch(scenceTypes.GET_STORAGE_CURVE_STATION, this.query).then(data => {
        if (data.rows.length > 0) {
          data.rows.forEach(d => {
            d.sttpStr = d.sttp.replace('RR', '水库站')
            d.sttpStr = d.sttpStr.replace('PP', '雨量站')
            d.sttpStr = d.sttpStr.replace('ZZ', '河道站')
          })
        }
        this.waterdata = data.rows
        this.getSpanArr(data.rows)
        this.loading = false
      })
    },
    onEdit (row) {
      this.diagTitle = row.stationName + '编辑'
      this.loading2 = true
      this.$store.dispatch(scenceTypes.GET_STORAGE_CURVE, { stationId: row.stationId }).then(data => {
        this.editdata = data.rows
        this.drawStorageLine(data.rows) // 库容曲线
        this.loading2 = false
      })
      this.diagShow = true
    },
    onSave () {
      this.$store.dispatch(scenceTypes.SAVE_STORAGE_CURVE, { rows: this.editdata }).then(data => {
        this.$notify.success({ title: '成功', message: '保存成功。' })
        this.diagShow = false
      })
    },
    getSpanArr (data) {
      this.spanArr = []
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
          if (data[i].stnm === data[i - 1].stnm) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2 || columnIndex === 3) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    drawStorageLine (data) {
      let xData = []
      let serData = []
      data.forEach(el => {
        xData.push(el.z)
        serData.push(el.v)
      })
      let arrFirst = []
      let arrFinal = []
      for (let i = 0; i < serData.length; i++) {
        arrFirst = [xData[i], serData[i]]
        arrFinal.push(arrFirst)
      }
      let myChart = this.$echarts.init(document.getElementById('storageLine'))
      myChart.clear()
      myChart.setOption({
        grid: {
          left: '8%',
          right: '7%',
          bottom: '5%',
          top: '6%'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params, ticket, callback) {
            let htmlStr = ''
            for (var i = 0; i < params.length; i++) {
              let param = params[i]
              let value = param.value// y轴值
              let color = param.color// 图例颜色
              let danwei = '万m³'
              if (i === 0) {
                htmlStr += `<div>
                <span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:${color};"></span>
                水位：${param.axisValue}m
              </div>`// x轴
              }
              htmlStr += `<div>
                <span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:${color};"></span>
                库容：${value[1]}${danwei}
              </div>`
            }
            return htmlStr
          }
        },
        xAxis: {
          type: 'value',
          name: ' 水 \n 位 \n(m)',
          min: Math.floor(xData[0]),
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              opacity: 0.5
            }
          },
          axisLine: {
            lineStyle: {
              color: '#ccc'
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '库容(万m³)',
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              opacity: 0.5
            }
          },
          axisLine: {
            lineStyle: {
              color: '#ccc'
            }
          }
        },
        series: [{
          data: arrFinal,
          symbolSize: 0,
          smooth: true,
          type: 'line',
          itemStyle: {
            color: '#87CEEB'
          },
          markLine: {
            symbol: 'none'
          }
        }]
      })
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
    this.onLoadData()
    this.$nextTick(() => {
      let selectDiv = document.getElementsByClassName('select')
      // let tabsDiv = document.getElementsByClassName('tabs')
      this.height = this.$refs['skt'].offsetHeight - selectDiv[0].offsetHeight - 30
    })
  }
}
</script>
<style lang="less" src="@/assets/usercenter.less" scoped></style>
<style lang="less" scoped>
.scence /deep/ .el-dialog {
  width: 70%;
}
.scence /deep/ .el-dialog__body {
  overflow: hidden !important;
}
/deep/ .el-form{
  width: 100% !important;
}
/deep/.el-form-item {
  width: 50% !important;
  float: left;
}
/deep/ .el-form-item__label{
  width: 100px !important;
}
.skt{
  height: calc(100% - 0px) !important;
}
.tabs{
  margin-bottom: 10px;
  height: 62px;
  background-color: #ffffff;
  border-radius: 5px;
  color: #444444;
  font-size: 15px;
  .country{
    float: left;
    font-family: Microsoft YaHei UI;
    font-size: 15px;
    text-align: center;
    margin-top: 20px;
    margin-left: 0.5%;
    cursor: pointer;
    .countryon, .categoryon{
      border-radius: 15px;
      background-color: #fda72c;
      color: #ffffff
    }
    span{
      padding: 4px 15px;
    }
  }
}
.note {
  color: #aaa;
  margin-left: 50px;
}
.app-container{
  width: 100%;
  height: 880px;
  position: relative;
  top: -80px;
  .filter-container {
    width: 100%;
    height: 80px;
    background: #ffffff;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 5px;
  }
  .el-table{
    background: #ffffff;
    border-radius: 5px;
  }
}
.operation{
  margin: 0!important;
}
.edit_dialog  {
  /deep/ .editInput{
    line-height: 26px;
    width: 100%;
    border: none;
    text-align: center;
    background: rgba(0,0,0,0);
    &:focus{
      outline: none;
    }
  }
}
.chartContainer {
  width: 100%;
  height: 100%;
    #storageLine{
    width: 100%;
    height: 500px;
  }
}

</style>
